import { render, staticRenderFns } from "./TaxQuickAddModal.vue?vue&type=template&id=47497b6d&scoped=true"
import script from "./TaxQuickAddModal.vue?vue&type=script&lang=js"
export * from "./TaxQuickAddModal.vue?vue&type=script&lang=js"
import style0 from "./TaxQuickAddModal.vue?vue&type=style&index=0&id=47497b6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47497b6d",
  null
  
)

export default component.exports